<div class="mct-flex mct-col mct-gap-27" *ngIf="eCommerceItem">
  <div>
    <p-checkbox [(ngModel)]="eCommerceItem.RestrictForMembersOnly" binary="true" inputId="restrictForMembersOnly"> </p-checkbox>
    <label for="restrictForMembersOnly">
      {{ 'ecommerce.item.restrictions.restrict-for-members' | translate | ucfirst }}
    </label>
  </div>
  <div class="mct-flex mct-col mct-gap-5 atlas-autocomplete">
    <div>
      <p-checkbox [(ngModel)]="eCommerceItem.RestrictForAffiliations" binary="true" inputId="restrictForAffiliations"> </p-checkbox>
      <label for="restrictForAffiliations">
        {{ 'ecommerce.item.restrictions.restrict-for-affcodes' | translate | ucfirst }}
      </label>
    </div>
    <p-autocomplete
      [inputStyle]="{ width: '100%' }"
      [multiple]="true"
      [forceSelection]="true"
      [dropdown]="true"
      [suggestions]="affCodeSearchResults"
      (completeMethod)="searchAffCodes($event)"
      [(ngModel)]="selectedAffCodes"
      (onSelect)="affCodeSelected()"
      (onUnselect)="affCodeSelected()"
      appendTo="body"
    >
    </p-autocomplete>
  </div>
  <div>
    <p-checkbox
      [(ngModel)]="eCommerceItem.ShowAsTeaserIfRestricted"
      [trueValue]="false"
      [falseValue]="true"
      binary="true"
      inputId="showAsTeaserIfRestricted"
    >
    </p-checkbox>
    <label for="showAsTeaserIfRestricted">
      {{ 'ecommerce.item.restrictions.show-teaser-for-unqualified' | translate | ucfirst }}
    </label>
  </div>
  <div>
    <label>
      {{ 'ecommerce.item.restrictions.teaser-message' | translate | ucfirst }}
    </label>
    <input [disabled]="!eCommerceItem.ShowAsTeaserIfRestricted" [(ngModel)]="eCommerceItem.TeaserMessage" class="form-control" />
  </div>
  <div>
    <label>
      {{ 'ecommerce.item.restrictions.restricted-message' | translate | ucfirst }}
    </label>
    <input [disabled]="!eCommerceItem.ShowAsTeaserIfRestricted" [(ngModel)]="eCommerceItem.RestrictedMessage" class="form-control" />
  </div>
</div>
